import { create } from 'zustand';
import { Employe } from '../types';

interface EmployesStore {
  employeSelectionne: Employe | null;
  filtresListe: { actif?: boolean; recherche: string; idProjet?: string };
  pageEnCours: number;

  setEmployeSelectionne: (e: Employe | null) => void;
  setFiltres: (f: Partial<EmployesStore['filtresListe']>) => void;
  setPage: (p: number) => void;
}

export const useEmployesStore = create<EmployesStore>((set) => ({
  employeSelectionne: null,
  filtresListe: { recherche: '' },
  pageEnCours: 1,

  setEmployeSelectionne: (e) => set({ employeSelectionne: e }),
  setFiltres: (f) => set(s => ({ filtresListe: { ...s.filtresListe, ...f }, pageEnCours: 1 })),
  setPage: (p) => set({ pageEnCours: p }),
}));
